export default __webpack_public_path__ + "static/media/Classwin_Menu-pop-up_3-Member.062acf53.jpeg";